const departments = {
    leader: 'Руководитель',
    leaders: 'Руководители отдела',
    led_departments: 'Подчинённые отделы',
    edit_leaders: 'Настроить руководителей',
    add_leader: 'Добавить',
    remove_leader: 'Убрать',
    no_leaders: 'Руководители не назначены',
    local: 'Локальная настройка',
    managed_members: 'Участники в области управления',
    leader_scope_hint: 'Управляйте составом своих отделов и подотделов.',
    leader_permission_hint: 'Руководители управляют составом своих отделов и подотделов, но не ролями организации или структурой отделов.',
    primary_synced: 'Основной отдел управляется в Feishu.',
    status_active: 'Активен',
    status_suspended: 'Приостановлен',
    status_departed: 'Уволен',
    status_pending: 'Ожидает активации',
    search: 'Поиск',
    previous_page: 'Предыдущая страница',
    next_page: 'Следующая страница',
    directory_title: 'Участники организации',
    member_name: 'Участник',
    search_members: 'Поиск по имени или логину',
    include_descendants: 'Включить подразделы',
    no_members: 'Подходящих участников нет.',
    all_members: 'Все участники',
    all_departments: 'Все отделы',
    edit_member: 'Изменить отделы',
    add_child: 'Добавить подраздел',
    expand_department: 'Развернуть {{name}}',
    collapse_department: 'Свернуть {{name}}',
    title: 'Отделы',
    description: 'Управление отделами и назначениями участников этой организации.',
    create: 'Создать отдел',
    edit: 'Изменить отдел',
    name: 'Название отдела',
    parent: 'Родительский отдел',
    root: 'Без родительского отдела',
    id: 'ID отдела',
    members: 'Отделы участников',
    member_id: 'ID пользователя участника',
    primary: 'Основной отдел',
    none: 'Не задан',
    assignments: 'Назначения отделов',
    no_assignments: 'Назначений отделов пока нет.',
    assignment_hint: 'Назначьте локальные отделы и при необходимости основной отдел. Назначения из каталога доступны только для чтения.',
    empty: 'Отделов пока нет.',
    readonly: 'Вы можете просматривать отделы и свои назначения. Для изменений обратитесь к администратору организации.',
    load_error: 'Не удалось загрузить данные. Повторите попытку.',
    mutation_error: 'Не удалось сохранить. Проверьте права, членство и иерархию отделов.',
    loading: 'Загрузка…',
    synced: 'Управляется каталогом',
    choose: 'Поиск отделов',
    organizations_title: 'Организации и отделы',
    organizations_description: 'Выберите организацию для просмотра или управления её отделами.',
    no_organizations: 'Вы не состоите в организации. Обратитесь к администратору.',
    organization: 'Текущая организация',
    choose_organization: 'Выберите организацию',
    delete_title: 'Удалить отдел',
    delete_description: 'Удалить «{{name}}»? Сначала переместите участников и дочерние отделы.',
};
export default Object.freeze(departments);
